import { lazy, Suspense } from "react"
import AddBankAccount from "./addBankAccount/AddBankAccount"

const Home = lazy(() => import("./home/home"))
const Login = lazy(() => import("./login/login"))
const CreditLoading = lazy(() => import("./creditLoading/creditLoading"))
const CreditResult = lazy(() => import("./creditResult/creditResult"))
const ApplyQuota = lazy(() => import("./applyQuota/ApplyQuota"))
const IdentityOCR = lazy(() => import("./identityOCR/IdentityOCR"))
const InformationForm = lazy(() => import("./informationForm/InformationForm"))
const AgreementList = lazy(() => import("./agreementList/AgreementList"))
const AgreementDetail = lazy(() => import("./agreementDetail/AgreementDetail"))
const SuccessPage = lazy(() => import("./successPage/successPage"))
const router = [
  {
    path: "home", // 首页
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "login", // 登录
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "creditLoading", // 授信结果等待
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CreditLoading />
      </Suspense>
    ),
  },
  {
    path: "previewCheck", // 预审中/提交成功页面
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CreditResult />
      </Suspense>
    ),
  },
  {
    path: "applyQuota", // 申请额度
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ApplyQuota />
      </Suspense>
    ),
  },
  {
    path: "identityOCR", // 身份证OCR
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <IdentityOCR />
      </Suspense>
    ),
  },
  {
    path: "informationForm", // 信息确认
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <InformationForm />
      </Suspense>
    ),
  },
  {
    path: 'addBankAccount', // 绑卡
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <AddBankAccount />
      </Suspense>
    ),
  },
  {
    path: 'agreementList', // 协议列表
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <AgreementList />
      </Suspense>
    ),
  },
  {
    path: 'agreementDetail', // 协议详情
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <AgreementDetail />
      </Suspense>
    ),
  },
  {
    path: 'successPage', // 结果页
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SuccessPage />
      </Suspense>
    ),
  }
]

export default router
